// import React from "react";
// import Sidebar from "../components/Sidebar";
// import Navbar from "../components/Navbar";
// import TabPage from "../components/TabPage";
// import { useLocation } from "react-router-dom";

// const TwoTabsPage = () => {
//   const location = useLocation();
//   console.log("location::", location);
//   return (
//     <>
//       <Sidebar />
//       <Navbar />
//       <TabPage />
//     </>
//   );
// };

// export default TwoTabsPage;
import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import TabPage from "../components/TabPage";

const TwoTabsPage = () => {
  const [companyData, setCompanyData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Get companyId from URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    const companyId = urlParams.get("companyId");

    if (companyId) {
      // First try to get from localStorage
      const storedData = localStorage.getItem(`companyData_${companyId}`);
      if (storedData) {
        const parsedData = JSON.parse(storedData);
        setCompanyData(parsedData);
        console.log("Retrieved company data from localStorage:", parsedData);
        setLoading(false);
        return;
      }

      // If not in localStorage, try sessionStorage (for same session)
      const sessionData = sessionStorage.getItem("companyData");
      if (sessionData) {
        const parsedData = JSON.parse(sessionData);
        if (parsedData.companyId === companyId) {
          setCompanyData(parsedData);
          // Also store in localStorage for future refreshes
          localStorage.setItem(
            `companyData_${companyId}`,
            JSON.stringify(parsedData)
          );
          console.log(
            "Retrieved company data from sessionStorage:",
            parsedData
          );
          sessionStorage.removeItem("companyData");
        }
      }
    }

    setLoading(false);
  }, []);

  // Clean up old localStorage entries (optional)
  useEffect(() => {
    const cleanupOldData = () => {
      const keys = Object.keys(localStorage);
      const now = Date.now();
      const maxAge = 24 * 60 * 60 * 1000; // 24 hours

      keys.forEach((key) => {
        if (key.startsWith("companyData_")) {
          try {
            const data = JSON.parse(localStorage.getItem(key));
            if (data.timestamp && now - data.timestamp > maxAge) {
              localStorage.removeItem(key);
            }
          } catch (e) {
            localStorage.removeItem(key);
          }
        }
      });
    };

    cleanupOldData();
  }, []);

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        Loading...
      </div>
    );
  }

  return (
    <>
      <Sidebar />
      <Navbar />
      <TabPage companyData={companyData} />
    </>
  );
};

export default TwoTabsPage;
